import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import StockBadge from "./StockBadge";
import { useLang } from "@/context/LangContext";

export const ProductCard = ({ product, index = 0 }) => {
  const { t } = useLang();
  const idc = product.slug || product.id;
  return (
    <Link
      to={`/product/${idc}`}
      data-testid={`product-card-${idc}`}
      className="group flex flex-col overflow-hidden rounded-xl border border-forest/10 bg-white transition-all duration-300 hover:-translate-y-1 hover:border-amber-brand/40 hover:shadow-xl"
    >
      <div className="relative aspect-[4/3] overflow-hidden bg-beige">
        {product.image ? (
          <img src={product.image} alt={product.product_name} loading="lazy" className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
        ) : (
          <div className="flex h-full w-full items-center justify-center bg-gradient-to-br from-forest/8 to-espresso/8">
            <span className="font-mono text-[10px] uppercase tracking-widest text-espresso/40">Photo updating soon</span>
          </div>
        )}
        <div className="absolute left-3 top-3">
          <StockBadge status={product.stock_status} testId={`card-badge-${idc}`} />
        </div>
        {product.featured && (
          <div className="absolute right-3 top-3 rounded-full bg-amber-brand px-2.5 py-1 font-mono text-[10px] font-bold uppercase tracking-wider text-espresso-dark">Featured</div>
        )}
      </div>
      <div className="flex flex-1 flex-col p-5">
        <div className="mb-1 font-mono text-[10px] uppercase tracking-[0.2em] text-amber-brand">{product.region || product.origin || "Indonesia"}</div>
        <h3 className="font-display text-lg font-bold leading-tight text-forest-dark">{product.product_name}</h3>
        <div className="mt-3 grid grid-cols-2 gap-x-3 gap-y-1.5 font-mono text-[11px] text-espresso/70">
          {product.process && <div><span className="text-espresso/40">Process</span><br />{product.process}</div>}
          {product.grade && <div><span className="text-espresso/40">Grade</span><br />{product.grade}</div>}
          {product.screen_size && <div><span className="text-espresso/40">Screen</span><br />{product.screen_size}</div>}
          {product.moisture && <div><span className="text-espresso/40">Moisture</span><br />{product.moisture}</div>}
        </div>
        <div className="mt-auto flex items-center justify-between pt-4">
          <div className="font-body text-sm">
            {product.available_stock > 0 ? (
              <span className="font-semibold text-forest">{product.available_stock.toLocaleString()} {product.stock_unit}</span>
            ) : (
              <span className="text-espresso/50">{t("cta.quote")}</span>
            )}
          </div>
          <span className="flex items-center gap-1 font-mono text-[11px] font-semibold uppercase tracking-wider text-forest transition-colors group-hover:text-amber-brand">
            {t("common.viewProduct")} <ArrowUpRight className="h-3.5 w-3.5" />
          </span>
        </div>
      </div>
    </Link>
  );
};

export default ProductCard;
